import getStatusString from './get-status-string.js';


const downloadReceipt = async (theapp, tx_info) => {
	console.log('downloadReceipt called');

	let mvcmywidget = theapp.getMvcMyWidget();
	let start_conditions = theapp.getStartConditions();

	if (!start_conditions)
	return;

	let date = mvcmywidget.formatDate(tx_info.time, 'YYYY-mm-dd HH:MM:SS');

	let _cr = '\r\n';
	let receipt_string = 'TRANSACTION RECEIPT' + _cr + _cr;

	receipt_string += 'Amount: ' + tx_info.amount_string + _cr;
	receipt_string += 'Transaction hash: ' + tx_info.hash + _cr;
	receipt_string += 'Date: ' + date + _cr;
	receipt_string += 'Status: ' + getStatusString(theapp, tx_info.status_int) + _cr;

	const receipt_span = document.getElementById('receipt-icon');

	const element = document.createElement('a');

	
	// change date to comply with file name constraints
	var filedate = date.replace(' ', '_');
	filedate = filedate.replace(':', 'h');
	filedate = filedate.replace(':', 'm');
	
	const file = new Blob([receipt_string], {type: 'text/plain'});
	element.href = URL.createObjectURL(file);
	element.download = 'receipt-' + filedate + '.txt';
	receipt_span.appendChild(element); // Required for this to work in FireFox
	element.click();
}

export default downloadReceipt;